import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { SIcon } from "./components";
import _ from "lodash";
export const SDropdownV3 = ({ options, value: _value, onChange, customOnClick, showIcon = true, borderless = true, name, disabled = false, className, children, tabIndex, placeholder = "Select one...", labelClassName, deselectable = undefined })=>{
    const borderClassStyles = borderless ? "" : "px-3  h-[32px] bg-grayscale-dark border border-white/10 rounded-md flex flex-row items-center justify-between";
    const value = useMemo(()=>{
        if (typeof _value === "string") {
            return options.find((o)=>o.value === _value);
        }
        return _value;
    }, [
        _value,
        options
    ]);
    const isGroupingEnabled = useMemo(()=>{
        // if all options have a group, return true
        const hasGroups = options.some((o)=>o.group);
        const uniqueDefinedGroups = [
            ...new Set(options.map((o)=>o.group))
        ];
        return hasGroups && uniqueDefinedGroups.length > 1;
    }, [
        options
    ]);
    // an array of unique groups appearing in the order of first appearance
    const uniqueGroups = useMemo(()=>{
        return isGroupingEnabled ? [
            ...new Set(options.map((o)=>o.group))
        ] : [];
    }, [
        options,
        isGroupingEnabled
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: `${disabled ? "cursor-not-allowed" : "cursor-pointer"} group relative ${borderClassStyles} text-[13px] ${className}`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: `${disabled ? "opacity-50" : "group-hover:opacity-50"} transition grid grid-cols-[1fr,auto] items-center justify-center ${showIcon ? "gap-2" : ""} ${!borderless ? "w-full" : ""}`,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: children || (value?.label ? /*#__PURE__*/ _jsx("p", {
                            className: `truncate max-w-[270px] ${labelClassName}`,
                            children: value.label
                        }) : /*#__PURE__*/ _jsx("p", {
                            className: "text-[#6B7280]",
                            children: placeholder
                        }))
                    }),
                    showIcon && /*#__PURE__*/ _jsx(SIcon, {
                        className: "opacity-30",
                        type: "chevron-down",
                        size: 10
                    })
                ]
            }),
            customOnClick ? /*#__PURE__*/ _jsx("div", {
                onClick: disabled ? ()=>{} : customOnClick,
                className: `${disabled ? "cursor-not-allowed" : "cursor-pointer"} absolute top-0 left-0 right-0 bottom-0 opacity-0`
            }) : /*#__PURE__*/ _jsxs("select", {
                disabled: disabled,
                name: name,
                value: value?.value || "",
                tabIndex: tabIndex,
                onChange: (e)=>{
                    console.log("e.target.value", e.target.value);
                    if (e.target.value === "" && deselectable) {
                        onChange({
                            label: "",
                            value: ""
                        });
                    } else {
                        const selectedOption = options.find((o)=>o.value === e.target.value);
                        if (selectedOption && !selectedOption.disabled) {
                            onChange(selectedOption);
                        }
                    }
                },
                className: `${disabled ? "cursor-not-allowed" : "cursor-pointer"} absolute top-0 left-0 right-0 bottom-0 opacity-0 bg-transparent !px-0 !mx-0 rounded-full  !border-color-[rgba(0,0,0,0)] !border-0 !text-sm `,
                children: [
                    value === undefined || deselectable ? deselectable ? /*#__PURE__*/ _jsx("option", {
                        value: "",
                        className: "text-black",
                        children: deselectable?.label
                    }) : /*#__PURE__*/ _jsx("option", {
                        value: "",
                        className: "text-black",
                        children: placeholder
                    }) : null,
                    isGroupingEnabled ? uniqueGroups.map((group)=>group !== undefined ? /*#__PURE__*/ _jsx("optgroup", {
                            label: _.startCase(group),
                            className: "text-black/50",
                            children: options.filter((o)=>o.group === group).map((e, i)=>/*#__PURE__*/ _jsx("option", {
                                    value: e.value,
                                    disabled: e.disabled,
                                    className: "text-black disabled:text-black/50",
                                    children: e.label
                                }, `${e.value}-${i}`))
                        }, group) : options.filter((e)=>e.group === undefined).map((e, i)=>/*#__PURE__*/ _jsx("option", {
                                value: e.value,
                                disabled: e.disabled,
                                className: "text-black disabled:text-black/50",
                                children: e.label
                            }, `${e.value}-${i}`))) : options.map((e, i)=>/*#__PURE__*/ _jsx("option", {
                            value: e.value,
                            disabled: e.disabled,
                            className: "text-black disabled:text-black/50",
                            children: e.label
                        }, `${e.value}-${i}`))
                ]
            })
        ]
    });
};
